<template>
  <!-- 注：一定要用v-show，因为优惠券的数据是在组件内查询的 -->
  <div class="pc-coupon-card" v-show="isLogin" :style="moduleBackColor">
    <div class="title" :style="mFontColor">{{ renderTitle }}</div>
    <div class="body">
      <DesktopCoupon />
      <Empty v-show="!gameCouponList.length" />
    </div>
  </div>
</template>
<script>
  import DesktopCoupon from '../Coupon/new/desktop'
  import Empty from './Empty'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'new-pc-Coupon',
    mixins: [styleConfiguration],
    components: {
      Empty,
      DesktopCoupon,
    },
    props: {},
    data() {
      return {}
    },
    computed: {
      ...mapGetters('detail', ['gameCouponList']),
      ...mapGetters(['isLogin']),
      ...mapState('detail', ['paymentChannel']),
      renderTitle() {
        const titleMsg = this.$t('publicDetails.pc_select_coupon')

        let nums = '3'

        if (this.awardType === 2 || this.uidModuleType === 6) {
          nums = '4'
        }

        // 有一种情况是没有支付通道、全部的SKU都抽空了
        // undawn
        if (this.paymentChannel && this.paymentChannel.length === 0) {
          if (this.awardType === 2 || this.uidModuleType === 6) {
            nums = '3'
          } else {
            nums = '2'
          }
        }

        return `${nums}. ${titleMsg}`
      },
    },
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }

  @media (min-width: 768px) and (max-width: 1280px) {
    @import './index_pc.scss';
  }
</style>
